module.exports = __webpack_public_path__ + "img/blue_shield_generator_small.dce997e2.png";